import React from 'react';
import { CreditCardIcon } from 'lucide-react';
type CurrencyNoteProps = {
  className?: string;
};
export function CurrencyNote({
  className = ''
}: CurrencyNoteProps) {
  return <p className={`w-full text-balance text-center text-xs font-semibold leading-relaxed text-ink-soft sm:text-[13px] ${className}`} data-id="element-46" data-mp="195nif6nishiv">
      <CreditCardIcon className="mr-1.5 inline-block h-4 w-4 -translate-y-px align-middle text-ink-mute" aria-hidden="true" data-id="element-47" data-mp="1e3oydipng0q4" />
      Le paiement sera traité dans votre devise locale.
    </p>;
}